import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { format } from "date-fns";
import { IPermissionProps } from "../../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilter, Filter, IFilterTarget } from "./Filter";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface ITargetRecruiterHistory {
    user_Name?: string,
    team_Name?: string,
    login_ID?: number,
    sub?: number,
    req?: null,
    ecs?: number,
    eci?: number,
    po?: number,
    yesterday_Total_SUB?: number,
    yesterday_Total_ECI?: number,
    yesterday_Total_ECS?: number,
    period_Total_SUB?: number,
    period_Total_ECI?: number,
    period_Total_ECS?: number,
    period_Total_PO?: number,
}

export const TargetRecruiterHistory = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITargetRecruiterHistory>, loading: boolean });
    const [filters, setFilters] = useState<IFilterTarget>(EmptyFilter);
    const [tableLoad, setTableLoad] = useState(false);
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    // useEffect(() => {
    //     loadTableData();
    // }, [filters]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };
    // const today = new Date();
    // const previousDate = new Date(today);
    // const day = previousDate.getDate() - 1;
    // const month = previousDate.getMonth() + 1;
    // const year = previousDate.getFullYear();
    // const formattedDate = `${day}/${month}/${year}`;
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    const formattedDate = safeFormatDate(
        yesterday.toISOString(),
        "dd/MM/yyyy",
        DateFormat
    );


    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        //`filter=${JSON.stringify(filters)}`
        const response = await Fetch("Tbl_Targets/reportRecruiter", "GET", null, `filter=${JSON.stringify(filters)}`, toast);
        if (response) {
            const data: Array<ITargetRecruiterHistory> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }
    const rightToolbarTemplate = () => {
        return (
            permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Recruiter Target Report</h5>
        </div>
    );

    useEffect(() => {
        if(tableLoad){
        loadTableData();
        setTableLoad(false);
        }
    }, [filters]);



    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IFilterTarget) => setFilters(filters)} toast={toast} onSearch={()=> setTableLoad(true)}/>

                </AccordionTab>
            </Accordion>

            {permissions.is_View && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines scrollable resizableColumns scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                // paginator rows={10} rowsPerPageOptions={[10, 15, 20]}
                value={tableData.tableData}
                header={header}
                emptyMessage="No Data found."
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={() => { return <span className="font-bold">Total</span> }} />
                <Column field="team_Name" header="Team" />
                <Column field="user_Name" header="Name" />
                <Column field="sub" header="Sub Target" sortable className="bg-cyan-300"
                    footer={() => {
                        const SUB = tableData.tableData.reduce((sum, item) => sum + (item.sub || 0), 0);
                        return <span className="font-bold">{SUB}</span>;
                    }}
                />
                <Column field="yesterday_Total_SUB" header={`${formattedDate}`} className="bg-green-400"
                    footer={() => {
                        const YesterdaySUB = tableData.tableData.reduce((sum, item) => sum + (item.yesterday_Total_SUB || 0), 0);
                        return <span className="font-bold">{YesterdaySUB}</span>;
                    }}
                />
                <Column field="period_Total_SUB" header="Total Sub" className="bg-yellow-400"
                    footer={() => {
                        const totalReq = tableData.tableData.reduce((sum, item) => sum + (item.period_Total_SUB || 0), 0);
                        return <span className="font-bold">{totalReq}</span>;
                    }} />
                <Column field="ecs" header="ECS" className="bg-cyan-300"
                    footer={() => {
                        const ecs = tableData.tableData.reduce((sum, item) => sum + (item.ecs || 0), 0);
                        return <span className="font-bold">{ecs}</span>;
                    }}
                />
                <Column field="yesterday_Total_ECS" header={`${formattedDate}`} className="bg-green-400"
                    footer={() => {
                        const Yesterdayecs = tableData.tableData.reduce((sum, item) => sum + (item.yesterday_Total_ECS || 0), 0);
                        return <span className="font-bold">{Yesterdayecs}</span>;
                    }}

                />
                <Column field="period_Total_ECS" header="Total ECS" className="bg-yellow-400"
                    footer={(rowData) => {
                        const totalECS = tableData.tableData.reduce((sum, item) => sum + (item.period_Total_ECS || 0), 0);
                        return <span className="font-bold">{totalECS}</span>;
                    }} />
                <Column field="eci" header="ECI" className="bg-cyan-300"
                    footer={(rowData) => {
                        const ECI = tableData.tableData.reduce((sum, item) => sum + (item.eci || 0), 0);
                        return <span className="font-bold">{ECI}</span>;
                    }}

                />
                <Column field="yesterday_Total_ECI" header={` ${formattedDate}`} className="bg-green-400"
                    footer={(rowData) => {
                        const YesterdayECI = tableData.tableData.reduce((sum, item) => sum + (item.yesterday_Total_ECI || 0), 0);
                        return <span className="font-bold">{YesterdayECI}</span>;
                    }}

                />
                <Column field="period_Total_ECI" header="Total ECI" className="bg-yellow-400"
                    footer={() => {
                        const totalECI = tableData.tableData.reduce((sum, item) => sum + (item.period_Total_ECI || 0), 0);
                        return <span className="font-bold">{totalECI}</span>;
                    }} />
                <Column field="po" header="PO" className="bg-cyan-300"
                    footer={() => {
                        const po = tableData.tableData.reduce((sum, item) => sum + (item.po || 0), 0);
                        return <span className="font-bold">{po}</span>;
                    }}
                />
                <Column field="period_Total_PO" header="Total PO" className="bg-yellow-400"
                    footer={() => {
                        const totalPO = tableData.tableData.reduce((sum, item) => sum + (item.period_Total_PO || 0), 0);
                        return <span className="font-bold">{totalPO}</span>;
                    }} />
            </DataTable>}
            <Toast ref={toast} />
        </>
    );
}
